module.exports = __webpack_public_path__ + "static/media/pic14.0ce4bbed.jpg";